<template>
  <div class="wrapper">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/ourbrands' }">Our Brands</el-breadcrumb-item>
      <el-breadcrumb-item>Gigwi</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <img src="../assets/imgs/uploads/mobile/brandgigwi.png" style="width: 100vw;" alt="">
    </div>
    <div class="tit">Best Sellers</div>
    <div class="bsells">
      <div v-for="item in goods" :key="item.id" style="width: 56.779vw;height: 59.733vw;">
        <router-link :to="{ path: '/details', query: { spuId: item.id } }">
          <img v-lazy="item.spuImage" alt="" style="width: 43.979vw;height: 43.933vw;margin: 3vw 6.4vw;">
          <div style="margin-top: 3.733vw;font-size: 4.533vw;display: flex;justify-content: center;">
            <p style="font-weight: bold;font-size: 3.2vw;">{{ item.name }}</p>
          </div>
        </router-link>
      </div>
    </div>
    <div class="tit">Shop by Range</div>
    <div class="sbr">
      <div v-for="item in cat" :key="item.id" class="range">
        <img :src="item.imgPath" style="width: 26.667vw;height: 26.667vw;border-radius: 2.667vw;" alt="">
        <div class="tip">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="sbr" style="margin-top: 0;">
      <div v-for="item in dog" :key="item.id" class="range">
        <img :src="item.imgPath" style="width: 26.667vw;height: 26.667vw;border-radius: 2.667vw;" alt="">
        <div class="tip">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="ug">
      <div style="display: flex;justify-content: center;">
        <img src="../assets/imgs/uploads/Rectangle 172.png" style="width: 42.013vw;height: 11.893vw; object-fit: contain;" alt="">
      </div>
      <p class="ugtxt">We are a Hong Kong based company created back in 2010 that has a very simple mission since the
        first days of its establishment: to help people and their pets spend hours of fun together.
        Our commitment to pet needs requires a holistic approach to making toys. It begins by using research to understand
        what sort of materials combined together work best, it continues by bringing together people to develop new ideas,
        and it comes back round by measuring the outcomes of our products.
        We gather exceptional team of professionals from all over the world with various backgrounds, beliefs, and
        perspectives, but we all share one common dream: develop our products for the better and make you and your pet
        satisfied. Our production process pursues the highest world standards and we always strive for improvement and aim
        to provide the best quality products to our clients.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goods: [],
      cat: [
        { id: 1, imgPath: require('../assets/imgs/uploads/gigwicat1.jpg'), name: 'Cat' },
        { id: 2, imgPath: require('../assets/imgs/uploads/gigwicat4.jpg'), name: 'Cat Gift Box' },
        { id: 3, imgPath: require('../assets/imgs/uploads/gigwicat3.jpg'), name: 'Scratcher' },
        { id: 4, imgPath: require('../assets/imgs/uploads/gigwicat4.jpg'), name: 'Teaser Stick' },
        { id: 5, imgPath: require('../assets/imgs/uploads/gigwicat5.jpg'), name: 'Cat Tree' },
      ],
      dog: [
        { id: 1, imgPath: require('../assets/imgs/uploads/gigwidog1.jpg'), name: 'Dog' },
        { id: 2, imgPath: require('../assets/imgs/uploads/gigwidog4.jpg'), name: 'Dog Gift Box' },
        { id: 3, imgPath: require('../assets/imgs/uploads/gigwidog3.jpg'), name: 'Plush Toy' },
        { id: 4, imgPath: require('../assets/imgs/uploads/gigwidog4.jpg'), name: 'Chew Toy' },
        { id: 5, imgPath: require('../assets/imgs/uploads/gigwidog5.jpg'), name: 'Fetch&Retrive' },
      ],
    }
  },
  mounted() {
    this.getGigwiBestSells()
  },
  methods: {
    getGigwiBestSells() {
      this.$axios
        .post("/api/mall/home/getGigwiBestSells")
        .then(res => {
          this.goods = res.data.data;
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
  },
}
</script>
<style scoped>
.wrapper {
  font-size: 16px;
  border-top: 1px solid #c7c7c7;
  margin-top: -1px;
}

.tit {
  margin-top: 18px;
  font-size: 21px;
  text-align: center;
  font-weight: bold;
  color: #000;
}

.bsells {
  display: flex;
  overflow-x: scroll;
  height: 68.733vw;
  overflow-y: hidden;
}

.bsells::-webkit-scrollbar {
  display: none;
}

.sbr {
  margin-top: 46px;
  padding: 0 29px;
  display: flex;
  flex-wrap: wrap;
}

.range:nth-child(3n) {
  margin-right: 0;
}

.range {
  width: 100px;
  height: 100px;
  margin: 0 7px 15px 0;
  border-radius: 10px;
  position: relative;
}

.tip {
  position: absolute;
  left: 50%;
  top: 80%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 12px;
  color: #FFF;
}

.ug {
  margin-top: 40px;
  padding: 38px 29px 0;
  background-color: #CA141D;
}

.ugtxt {
  margin-top: 23px;
  padding-bottom: 40px;
  font-size: 17px;
  color: #FFF;
  text-align: center;
}
</style>